import { UntypedFormControl } from "@angular/forms";

export function validateEmailArrayFormControl(control: UntypedFormControl) {
  // Empty field is allowed
  if (!control.value) {
    return null;
  }
  // Single email validation RegExp
  const mailPattern: RegExp =
    /^[_a-z0-9-]+(\.[_a-z0-9-]+)*(\+[a-z0-9-]+)?@[a-z0-9-]+(\.[a-z0-9-]+)*$/i;
  const placeholderPattern: RegExp = /^\[\[.*\]\]$/;
  // We're allowing more than one, comma separated, also [[placeholders]]
  const emails = control.value;
  for (let i = 0; i < emails.length; i++) {
    const email = emails[i].trim();
    if (!mailPattern.test(email) && !placeholderPattern.test(email)) {
      return { wrongEmail: { value: control.value } };
    }
  }

  return null;
}
